import {
    server
} from "@/api";


export const admin = {
    overview: async (params) => {
        return await server().get('api/dashboard/admin/overview', { params })
    }
}

export default {
    admin
}